import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Slide } from '@material-ui/core';

export const Transition = React.forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />);

export const useStyles = makeStyles(() => ({
  titlesContainer: {
    width: '253px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    margin: '10px',
    border: '1px solid #ff9800',
    borderRadius: '20px',
    textAlign: 'start',
    flexWrap: 'wrap',
  },
  titles: {
    fontSize: '1rem',
    fontWeight: 'bold',
    margin: '0.5rem',
  },
  subTitles: {
    fontSize: '0.8rem',
    fontWeight: '100',
    margin: '0.5rem',
  },
  linesContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
    margin: '10px',
    border: '1px solid #ff9800',
    borderRadius: '20px',
    textAlign: 'start',
  },
}));
